<template>
  <div>
    <NavBar v-if="user" :user="user"></NavBar>

    <div class="map-page">
      <div class="panel-container">
        <div class="panel panel-default">
          <div class="panel-heading">
            <div class="filters">
              <form>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="input-group">
                      <div class="input-group-addon">
                        <i class="material-icons">location_on</i>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        name="origin"
                        placeholder="From"
                        v-model="filters.from"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <div class="input-group-addon">
                        <i class="material-icons">location_on</i>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        name="destination"
                        placeholder="To"
                        v-model="filters.to"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="input-group date">
                      <div class="input-group-addon">
                        <i class="material-icons">date_range</i>
                      </div>
                      <input
                        type="text"
                        id="date-picker"
                        name="date"
                        class="form-control datepicker"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-4">
                    <div class="input-group">
                      <div class="input-group-addon">
                        <i class="material-icons">timeline</i>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        name="code"
                        placeholder="Transfer code"
                        v-model="filters.transferCode"
                      />
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="input-group">
                      <div class="input-group-addon">
                        <i class="material-icons">bookmark_border</i>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        name="referenceNumber"
                        placeholder="Reference number"
                        v-model="filters.referenceNumber"
                      />
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-sm-10">
                    <div class="filter-group-row">
                      <div class="filter-item">
                        <input
                          type="checkbox"
                          id="on-time-checkbox"
                          v-model="filters.onTime"
                        />
                        <label
                          for="on-time-checkbox"
                          class="unselectable badge badge-outline badge-success"
                        >
                          on time
                        </label>
                      </div>
                      <div class="filter-item">
                        <input
                          type="checkbox"
                          id="delayed-checkbox"
                          v-model="filters.delayed"
                        />
                        <label
                          for="delayed-checkbox"
                          class="unselectable badge badge-outline badge-sennder"
                        >
                          delay > 20m
                        </label>
                      </div>
                      <div class="filter-item">
                        <input
                          type="checkbox"
                          id="very-delayed-checkbox"
                          v-model="filters.veryDelayed"
                        />
                        <label
                          for="very-delayed-checkbox"
                          class="unselectable badge badge-outline badge-danger"
                        >
                          delay > 40m
                        </label>
                      </div>
                      <div class="filter-item">
                        <input
                          type="checkbox"
                          id="ongoing-checkbox"
                          v-model="filters.ongoing"
                        />
                        <label
                          for="ongoing-checkbox"
                          class="unselectable badge badge-outline badge-grey"
                        >
                          ongoing
                        </label>
                      </div>
                      <div class="filter-item">
                        <input
                          type="checkbox"
                          id="arrived-checkbox"
                          v-model="filters.arrived"
                        />
                        <label
                          for="arrived-checkbox"
                          class="unselectable badge badge-outline badge-grey"
                        >
                          arrived
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-2 text-center">
                    <button
                      type="button"
                      class="btn btn-raised btn-primary"
                      @click="refresh"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="panel-body">
            <div
              v-show="transfersLoaded"
              :class="'map-item map-all ' + (selectedItem === null ? 'selected' : '')"
              @click="selectAll"
            >
              <div class="list-icon">
                <i class="material-icons">near_me</i>
              </div>
              <div class="list-content">
                <div class="transfer-info">
                  <h2 class="list-group-item-heading">
                    <translate>All transfers</translate>
                  </h2>
                </div>
              </div>
            </div>

            <TransferItem
              v-for="item in items"
              ref="transfers"
              data-test="transfer-item"
              :key="item.id"
              :item="item"
              :selectedItem="selectedItem"
              @selected="select"
            ></TransferItem>
          </div>
          <InfiniteLoading
            :identifier="scrollerId"
            @infinite="loadPageOfTransfers"
          ></InfiniteLoading>
        </div>

        <div class="last-refresh-time" v-show="transfersLoaded">
          <translate>Last auto-refresh:</translate>
          {{ lastRefreshTimeDelta }}
        </div>
      </div>
      <Map></Map>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import $ from 'jquery'
import '../../vendors/date-picker/datepicker'
import '../../vendors/date-picker/datepicker.css'
import baseController from '../../controllers/base'
import { dateToISO } from '../../common/utils'
import FullScreenMap from '../../controllers/full-screen-map'
import Order from '../../models/order'
import Transfer from '../../models/transfer'
import InfiniteLoading from 'vue-infinite-loading'
import Map from '../common/Map'
import NavBar from '../common/NavBar'
import TransferItem from './TransferItem'
import { queryAllTransfers, queryOrdersForTransfers } from './queries'

export default {
  components: {
    NavBar,
    Map,
    TransferItem,
    InfiniteLoading: InfiniteLoading
  },
  extends: baseController,
  props: ['user'],
  data() {
    return {
      selectedItem: null,
      lastRefresh: null,
      lastRefreshTimeDelta: moment().fromNow(),
      items: [],
      transfersLoaded: false,
      lastLoadedElement: -1,
      scrollerId: 0,
      filters: {
        date: dateToISO(),
        from: '',
        to: '',
        transferCode: '',
        referenceNumber: '',
        onTime: false,
        delayed: false,
        veryDelayed: false,
        ongoing: false,
        arrived: false
      }
    }
  },
  computed: {
    transferIds() {
      return this.items.map(transfer => transfer.id)
    },
    firstSelectedTransfer() {
      return _.find(this.$refs.transfers, transfer => transfer.selected)
    }
  },
  created() {
    setInterval(() => this.refresh(), 1000 * 60 * 5)
  },
  mounted() {
    this.map = new FullScreenMap($('#leaflet', this.$el))

    this.datePicker = $('[name=date]', this.$el)
    this.datePicker.change(() => {
      this.filters.date = dateToISO(this.datePicker.val(), 'DD/MM/YYYY')
    })
    this.datePicker.val(moment(this.filters.date).format('DD/MM/YYYY'))
    this.datePicker.bootstrapMaterialDatePicker({
      format: 'DD/MM/YYYY',
      time: false
    })
  },
  methods: {
    select({ item, layers, fitBounds }) {
      const itemHasChanged =
        fitBounds || (this.selectedItem && this.selectedItem.id) !== (item && item.id)
      this.map.render(layers, { fitBounds: itemHasChanged })
      this.selectedItem = item || null
    },
    selectAll() {
      this.select({
        fitBounds: true,
        layers: _.flatten(_.map(this.$refs.transfers, transfers => transfers.layers))
      })
    },
    refresh() {
      this.items = []
      this.lastLoadedElement = -1
      this.scrollerId += 1
    },
    updateLastRefreshTimeDelta() {
      this.lastRefreshTimeDelta = this.lastRefresh.fromNow()
    },
    renderMap() {
      const transfer = this.firstSelectedTransfer
      if (transfer) {
        transfer.select()
      } else {
        this.selectAll()
      }
    },
    async loadPageOfTransfers($state) {
      try {
        const data = await queryAllTransfers(this.filters, this.lastLoadedElement)
        const newTransfers = Transfer.many(data.transfers, 'startTime')

        if (newTransfers.length) {
          this.items = [...this.items, ...newTransfers]
          this.transfersLoaded = true

          if (this.user.inStaffGroup) {
            await this.loadOrders(this.transferIds)
          }
          this.lastLoadedElement = data.lastElement
          $state.loaded()
        } else {
          $state.complete()
        }
        this.lastRefresh = moment()
        this.$nextTick(() => this.renderMap())
      } catch (err) {
        console.error(err) // eslint-disable-line no-console
      }
    },
    async loadOrders(transferIds) {
      const ordersData = await queryOrdersForTransfers(transferIds)
      const orders = Order.many(ordersData)

      this.items.forEach(transfer => {
        const relatedOrder = orders.find(order => order.transferId === transfer.id)
        this.$set(transfer, 'order', relatedOrder)
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/_variables.scss';
</style>
